import { createSelector } from "reselect";

import { mapCountriesToCountryObjects } from "app/pages/sales-intelligence/sub-modules/intent/helpers/countries";
import { createStatePropertySelector } from "app/pages/workspace/sales/helpers";
import { selectIntentSlice } from "app/pages/workspace/sales/store/selectors";

const select = createStatePropertySelector(selectIntentSlice);

const selectIntentSignalCountries = select("countries");

export const selectIntentSignalCountriesDetails = createSelector(
    selectIntentSignalCountries,
    mapCountriesToCountryObjects,
);

export const selectIntentSignalSelectedTopics = select("selectedTopics");

export const selectIntentSignalSelectedTopicsCreatedAt = select("createdAt");

export const selectIsUserApprovedTerms = select("isUserApprovedTerms");

export const selectIsUserApprovedTermsFetched = select("isUserApprovedTermsFetched");
